export default "__VITE_ASSET__CkFFcvJT__"